import type { AccountType } from '@/entities/account';

export const openTradingAccUrl = (login: string, accType: AccountType) => {
  const params = new URLSearchParams({
    login: login,
    server:
      accType === 'spot' ? 'ttexchange.free2ex.net' : 'ttmarginal.free2ex.net',
  });

  const url = `https://live.free2ex.com/authentication?${params}`;

  window.open(url, '_blank');
};
